import { render, staticRenderFns } from "./navtab.vue?vue&type=template&id=70aa8ce1&scoped=true&"
import script from "./navtab.vue?vue&type=script&lang=js&"
export * from "./navtab.vue?vue&type=script&lang=js&"
import style0 from "./navtab.vue?vue&type=style&index=0&id=70aa8ce1&scoped=true&lang=scss&"
import style1 from "./navtab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aa8ce1",
  null
  
)

export default component.exports